import React from "react";
import { Button, Avatar } from "@mui/material";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { tokens } from "../theme";

// Plum is the default action. Marigold is never reachable here — a screen gets
// at most one marigold control, opted into explicitly.
const PrimaryBtn = styled(Button)({
  background: tokens.primary,
  color: tokens.onPrimary,
  fontSize: "0.875rem",
  lineHeight: 1.6,
  fontWeight: 600,
  whiteSpace: "nowrap",
  textAlign: "center",
  textTransform: "none",
  boxShadow: "none",
});

const primaryHoverSx = {
  "&:hover": { background: tokens.primaryHover, boxShadow: "none" },
  "&.Mui-disabled": { background: tokens.border, color: tokens.textDisabled },
};

const PrimaryButton = (props) => {
  const { onClick, disabled, startIcon, children, sx, to } = props;

  const handleOnClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  if (to) {
    return (
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
        <PrimaryBtn
           sx={{ ...sx, ...primaryHoverSx }}
          startIcon={startIcon?<Avatar src={startIcon} style={{ width: '1.25rem', height: '1.25rem' }}/>:null}
        >
          {children || "click me..."}
        </PrimaryBtn>
      </Link>
    );
  }

  return (
    <PrimaryBtn
     onClick={handleOnClick}
     disabled={disabled}
     sx={{ ...sx, ...primaryHoverSx }}
     startIcon={startIcon?<Avatar src={startIcon} style={{ width: '1.25rem', height: '1.25rem' }}/>:null}
    >
      {children || "click me..."}
    </PrimaryBtn>
  );
};

export default PrimaryButton;
